import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { PAGINE } from "..";
import imgGradimento from '../../assets/images/gradimento-colon.jpg';
import HeaderColon from "./components/HeaderColon";
import Footer from "../../components/Footer";
import PageContainer from "../../components/PageContainer";

const HomeGradimentoColon = ({ tipologia }) => {
    return <PageContainer tipologia={tipologia}>
        <Container className="bg-white p-0 pt-4 overflow-hidden rounded shadow">
            <HeaderColon />
            <Row>
                <Col xs={12} md={6} className="d-flex flex-column justify-content-center mb-4">
                    <img src={imgGradimento} className="img-home-gradimento" alt="Modulo di Gradimento - InSenoAllaSalute" />
                </Col>
                <Col className="p-4 info-gradimento d-flex flex-column justify-content-center" xs={12} md={6}>
                    <div>
                        Gentile utente,
                        <br /><br />
                        La ringraziamo per essersi rivolto alla nostra <strong>U.O.C. Gastroenterologia</strong> e Le chiediamo di dedicarci qualche minuto per capire se e come possiamo migliorare il servizio.
                        <div className="text-center mt-4 pt-4">
                            <small>Il questionario è anonimo.</small>
                        </div>
                    </div>
                </Col>
            </Row>

            <section className="py-4">
                <Row>
                    <Col >
                        <nav className="text-center">
                            <Link to={`/${tipologia.URL}${PAGINE.MODULO_GRADIMENTO.URL}`} className="btn-inizia"><span>Inizia il</span><span className="questionario-link"> questionario</span></Link>
                        </nav>
                    </Col>
                </Row>
            </section>

            <Footer tipologia={tipologia} />

        </Container>
    </PageContainer>
}

export default HomeGradimentoColon;